import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BaseComponent } from './views/layout/base/base.component';
import { AuthGuard } from './core/guard/auth.guard';
import { ErrorPageComponent } from './views/pages/error-page/error-page.component';

const routes: Routes = [
  { path: 'auth', loadChildren: () => import('./views/pages/auth/auth.module').then(m => m.AuthModule) },
  { path: 'public/dispatch-details/:id', loadChildren: () => import('./views/pages/public-dispatch/public-dispatch.module').then(m => m.PublicDispatchModule) },
  { path: 'public/dispatch-details', loadChildren: () => import('./views/pages/public-dispatch/public-dispatch.module').then(m => m.PublicDispatchModule) },
  { path: 'dispatch-details/:id', loadChildren: () => import('./views/pages/public-dispatch/public-dispatch.module').then(m => m.PublicDispatchModule) },
  { path: 'dispatch-details', loadChildren: () => import('./views/pages/public-dispatch/public-dispatch.module').then(m => m.PublicDispatchModule) },
  { path: 'public/transit-details/:id', loadChildren: () => import('./views/pages/public-transit/public-transit.module').then(m => m.PublicTransitModule) },
  { path: 'public/transit-details', loadChildren: () => import('./views/pages/public-transit/public-transit.module').then(m => m.PublicTransitModule) },
  { path: 'transit-details/:id', loadChildren: () => import('./views/pages/public-transit/public-transit.module').then(m => m.PublicTransitModule) },
  { path: 'transit-details', loadChildren: () => import('./views/pages/public-transit/public-transit.module').then(m => m.PublicTransitModule) },
  { path: 'api/ump/order', loadChildren: () => import('./views/pages/ump-payment/ump-payment.module').then(m => m.UmpPaymentModule) },
  { path: 'ump/order', loadChildren: () => import('./views/pages/ump-payment/ump-payment.module').then(m => m.UmpPaymentModule) },
  { path: 'ump/pay', loadChildren: () => import('./views/pages/ump-payment/ump-payment.module').then(m => m.UmpPaymentModule) },
  {
    path: '',
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'finalmimasdashboard',
        loadChildren: () => import('./views/pages/finalmimasdashboard/finalmimasdashboard.module').then(m => m.FinalmimasdashboardModule)
      },
      {
        path: 'enforcement',
        loadChildren: () => import('./views/pages/enforcement/enforcement.module').then(m => m.EnforcementModule)
      },
      {
        path: 'get-vehicle-owner',
        loadChildren: () => import('./views/pages/get-vehicle-owner/get-vehicle-owner.module').then(m => m.GetVehicleOwnerModule)
      },
      {
        path: 'home',
        loadChildren: () => import('./views/pages/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./views/pages/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'epermit-dashboard',
        loadChildren: () => import('./views/pages/epermit-dashboard/epermit-dashboard.module').then(m => m.EPermitDashboardModule)
      },
      {
        path: 'dashboardnew',
        loadChildren: () => import('./views/pages/dashboard-new/dashboard-new.module').then(m => m.DashboardNewModule)
      },
      {
        path: 'dashboard/:id',
        loadChildren: () => import('./views/pages/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./views/pages/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'districtdashboard/:id',
        loadChildren: () => import('./views/pages/districtdashboard/districtdashboard.module').then(m => m.DistrictDashboardModule)
      },
      {
        path: 'application',
        loadChildren: () => import('./views/pages/applications/applications.module').then(m => m.ApplicationsModule)
      },
      {
        path: 'configuration',
        loadChildren: () => import('./views/pages/configuration/configuration.module').then(m => m.ConfigurationModule)
      },
      {
        path: 'report/:id',
        loadChildren: () => import('./views/pages/report/report.module').then(m => m.ReportModule)
      },
      {
        path: 'existing-mine-report',
        loadChildren: () => import('./views/pages/existing-mine-report/report.module').then(m => m.ReportModule)
      },
      {
        path: 'epermit-report/:id',
        loadChildren: () => import('./views/pages/epermit-report/epermit-report.module').then(m => m.EPermitReportModule)
      },
      {
        path: 'search',
        loadChildren: () => import('./views/pages/epermits/search-popup/search-popup.module').then(m => m.SearchPopupModule)
      },
      {
        path: 'completed',
        // loadChildren: () => import('./views/pages/completed-certificate/completed-certificate.module').then(m=> m.CompletedCertificateModule)
        loadChildren: () => import('./views/pages/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'existingmines',
        loadChildren: () => import('./views/pages/districtwise-existing-mineral-list/districtwise-existing-mineral-list.module').then(m => m.DistrictWiseExistingMineralListModule)
      },
      {
        path: 'districtwisemembers',
        loadChildren: () => import('./views/pages/districtwise-registered-members-report/districtwise-registered-members-report.module').then(m => m.DistrictWiseRegisteredMembersModule)
      },
      {
        path: 'applynew/list',
        loadChildren: () => import('./views/pages/applynew-list/applynew-list.module').then(m => m.ApplynewListModule)
      },
      {
        path: 'master',
        loadChildren: () => import('./views/pages/master-data/master-data.module').then(m => m.MasterDataModule)
      },
      {
        path: 'grievances',
        loadChildren: () => import('./views/pages/grievances/grievances.module').then(m => m.GrievancesModule)
      },
      {
        path: 'editgrievances/:id',
        loadChildren: () => import('./views/pages/grievances/editgrievance/editgrievance.module').then(m => m.EditgrievancesModule)
      },
      {
        path: 'vehiclelist',
        loadChildren: () => import('./views/pages/vehicle-registration/vehicle-registration.module').then(m => m.VehicleRegistrationModule)
      },
      {
        path: 'vehiclelist/register',
        loadChildren: () => import('./views/pages/vehicle-registration/register-vehicle/register-vehicle.module').then(m => m.RegisterVehicleModule)
      },
      {
        path: 'livetracklist',
        loadChildren: () => import('./views/pages/livetracking/livetracking.module').then(m => m.LiveTrackingModule)
      },
      {
        path: 'livetrack',
        loadChildren: () => import('./views/pages/tracking/livetrack/livetrack.module').then(m => m.LivetrackModule)
      },
      {
        path: 'multitrackview',
        loadChildren: () => import('./views/pages/tracking/multitrackview/multitrackview.module').then(m => m.MultitrackviewModule)
      },
      {
        path: 'livetracksingleview',
        loadChildren: () => import('./views/pages/tracking/livetracksingleview/livetracksingleview.module').then(m => m.LivetracksingleviewModule)
      },
      {
        path: 'triplivetracklist/:id',
        loadChildren: () => import('./views/pages/tripwiselivetrack/tripwisetrack-list/tripwisetrack-list.module').then(m => m.TripwisetrackListModule)
      },
      {
        path: 'livetrackingtrip/:typeId/:tripId/:vehicleId',
        loadChildren: () => import('./views/pages/tripwiselivetrack/tripwiselivetrack/tripwiselivetrack.module').then(m => m.TripwiselivetrackModule)
      },
      {
        path: 'livetracking/:typeId',
        loadChildren: () => import('./views/pages/tripwiselivetrack/tripwiselivetrack/tripwiselivetrack.module').then(m => m.TripwiselivetrackModule)
      },
      {
        path: 'tripPlayback',
        loadChildren: () => import('./views/pages/tripwiselivetrack/tripwise-playback/tripwise-playback.module').then(m => m.TripwisePlaybackModule)
      },
      {
        path: 'installedDevices',
        loadChildren: () => import('./views/pages/device-approval/devices-installed-list/devices-installed-list.module').then(m => m.DevicesInstalledListModule)
      },
      {
        path: 'vts/master/deviceimport',
        loadChildren: () => import('./views/pages/device-approval/master/device-import/device-import.module').then(m => m.DeviceImportModule)
      },
      {
        path: 'vts/master/manufacturers',
        loadChildren: () => import('./views/pages/device-approval/master/manufacturers/manufacturers.module').then(m => m.ManufacturersModule)
      },
      {
        path: 'vts/master/devicelist',
        loadChildren: () => import('./views/pages/device-approval/master/device-list/device-list.module').then(m => m.DeviceListModule)
      },

      // {
      //   path: 'playback/:id',
      //   loadChildren: () => import('./views/pages/playback/playbackdetail/playbackdetail.module').then(m => m.PlayBackDetailModule)
      // },
      {
        path: 'playback',
        loadChildren: () => import('./views/pages/playback/playback.module').then(m => m.PlaybackModule)
      },
      {
        path: 'editdevice/:id',
        loadChildren: () => import('./views/pages/vehicle-registration/editdevice/editdevice.module').then(m => m.EditDeviceModule)
      },
      {
        path: 'editvehicle/:id',
        loadChildren: () => import('./views/pages/vehicle-registration/editvehicle/editvehicle.module').then(m => m.EditVehicleModule)
      },
      {
        path: 'viewvehicle/:id',
        loadChildren: () => import('./views/pages/vehicle-registration/viewvehicle/viewvehicle.module').then(m => m.ViewvehicleModule)
      },

      {
        path: 'users',
        loadChildren: () => import('./views/pages/user-management/user-management.module').then(m => m.UserManagementModule)
      },
      {
        path: 'adduser',
        loadChildren: () => import('./views/pages/user-management/adduser/adduser.module').then(m => m.AddUserModule)
      },
      {
        path: 'edituser/:id',
        loadChildren: () => import('./views/pages/user-management/edituser/edituser.module').then(m => m.EditUserModule)
      },
      {
        path: 'epermits',
        loadChildren: () => import('./views/pages/epermits/epermits.module').then(m => m.EpermitsModule)
      },
      {
        path: 'applyepermit',
        loadChildren: () => import('./views/pages/epermits/applyepermit/applyepermit.module').then(m => m.ApplyEpermitModule)
      },
      {
        path: 'editepermit/:id',
        loadChildren: () => import('./views/pages/epermits/editepermit/editepermit.module').then(m => m.EditEpermitModule)
      },
      {
        path: 'viewepermit/:id',
        loadChildren: () => import('./views/pages/epermits/viewepermit/viewepermit.module').then(m => m.ViewEpermitModule)
      },

      {
        path: 'securitypaper-status',
        loadChildren: () => import('./views/pages/securitypaper/securitypaper-status/securitypaper-status.module').then(m => m.SecuritypaperStatusModule)
      },

      {
        path: 'securitypaper-count',
        loadChildren: () => import('./views/pages/securitypaper/securitypaper-count/securitypaper-count.module').then(m => m.SecuritypaperCountModule)
      },

      {
        path: 'securitypapers',
        loadChildren: () => import('./views/pages/securitypaper/securitypaperlist/securitypaperlist.module').then(m => m.SecurityPaperListModule)
      },
      {
        path: 'spList/:id',
        loadChildren: () => import('./views/pages/securitypaper/securitypaperlist/securitypaperlist.module').then(m => m.SecurityPaperListModule)
      },
      {
        path: 'sp-receivedlist',
        loadChildren: () => import('./views/pages/securitypaper/securitypaper-receivedlist/securitypaper-receivedlist.module').then(m => m.SecuritypaperReceivedlistModule)
      },

      {
        path: 'batchlist',
        loadChildren: () => import('./views/pages/securitypaper-batchlist/securitypaper-batchlist.module').then(m => m.SecuritypaperBatchlistModule)
      },
      {
        path: 'addDistrictbatch',
        loadChildren: () => import('./views/pages/securitypaper/assign-district-batch-add/assign-district-batch-add.module').then(m => m.AssignDistrictBatchAddModule)
      },
      {
        path: 'districtBatchList',
        loadChildren: () => import('./views/pages/securitypaper/assign-district-batch-list/assign-district-batch-list.module').then(m => m.AssignDistrictBatchListModule)
      },
      {
        path: 'damagelist',
        loadChildren: () => import("./views/pages/securitypaper/securitypaper-damagelist/securitypaper-damagelist.module").then(m => m.SecuritypaperDamagelistModule)
      },
      {
        path: 'paperdetails/:id/:condition',
        loadChildren: () => import('./views/pages/securitypaper-batchlist/paperdetailslist/paperdetailslist.module').then(m => m.PaperdetailslistModule)
      },
      {
        path: 'add-damaged',
        loadChildren: () => import('./views/pages/securitypaper-batchlist/add-damaged/add-damaged.module').then(m => m.AddDamagedModule)
      },
      {
        path: 'compayments',
        loadChildren: () => import('./views/pages/compayment/compayment.module').then(m => m.ComPaymentModule)
      },
      {
        path: 'mineralcost',
        loadChildren: () => import('./views/pages/mineralcost/mineralcost.module').then(m => m.MineralcostModule)
      },

      {
        path: 'securitypaperadd',
        loadChildren: () => import('./views/pages/securitypaper/securitypaperadd/securitypaperadd.module').then(m => m.SecurityPaperAddModule)
      },
      {
        path: 'securitypaperedit/:id',
        loadChildren: () => import('./views/pages/securitypaper/securitypaperedit/securitypaperedit.module').then(m => m.SecurityPaperEditModule)
      },
      {
        path: 'securitypaperview/:id',
        loadChildren: () => import('./views/pages/securitypaper/securitypaperview/securitypaperview.module').then(m => m.SecuritypaperviewModule)
      },
      {
        path: 'securitypaper-report/:id',
        loadChildren: () => import('./views/pages/securitypaper/securitypaper-report/securitypaper-report.module').then(m => m.SecuritypaperReportModule)
      },

      {
        path: 'subusers',
        loadChildren: () => import('./views/pages/subuser/subuserlist.module').then(m => m.SubUserModule)
      },

      {
        path: 'dispatchsliplist',
        loadChildren: () => import('./views/pages/dispatchslip/dispatchslip.module').then(m => m.DispatchSlipModule)
      },
      {
        path: 'createdispatchsliplist',
        loadChildren: () => import('./views/pages/dispatchslip/dispatchslip.module').then(m => m.DispatchSlipModule)
      },
      {
        path: 'dispatchreport',
        loadChildren: () => import('./views/pages/dispatchreport/dispatchreport.module').then(m => m.DispatchReportModule)
      },
      {
        path: 'vehicleinoutlist',
        loadChildren: () => import('./views/pages/vehicleinout/vechicleinlist.module').then(m => m.VechicleInListModule)
      },

      {
        path: 'vehiclein/:pathId',
        loadChildren: () => import('./views/pages/vehicleinout/vechiclein/vechiclein.module').then(m => m.VechicleInModule)
      },
      {
        path: 'vehicleout/:pathId/:vehicleId',
        loadChildren: () => import('./views/pages/vehicleinout/vechiclein/vechiclein.module').then(m => m.VechicleInModule)
      },
      {
        path: 'applydispatchslip',
        loadChildren: () => import('./views/pages/dispatchslip/applydispatchslip/applydispatchslip.module').then(m => m.ApplyDispatchSlipModule)
      },
      {
        path: 'editdispatchslip/:id',
        loadChildren: () => import('./views/pages/dispatchslip/editdispatchslip/editdispatchslip.module').then(m => m.EditDispatchSlipModule)
      },
      {
        path: 'changevehicle',
        loadChildren: () => import('./views/pages/changevehicle/changevehicle.module').then(m => m.ChangeVehicleModule)
      },
      {
        path: 'weighbridges',
        loadChildren: () => import('./views/pages/weighbridge/weighbridge.module').then(m => m.WeighBridgeModule)
      },
      {
        path: 'weighbridgeregister',
        loadChildren: () => import('./views/pages/weighbridge/weighbridge-register/weighbridge-register.module').then(m => m.WeighBridgeRegisterModule)
      },
      {
        path: 'transitpasslist',
        loadChildren: () => import('./views/pages/transitslip/transitslip.module').then(m => m.TransitSlipModule)
      },
      {
        path: 'createtransitpasslist',
        loadChildren: () => import('./views/pages/transitslip/transitslip.module').then(m => m.TransitSlipModule)
      },
      {
        path: 'applytransit',
        loadChildren: () => import('./views/pages/transitslip/applytransitslip/applytransitslip.module').then(m => m.ApplyTransitSlipModule)
      },
      {
        path: 'edittransit/:id',
        loadChildren: () => import('./views/pages/transitslip/edittransitslip/edittransitslip.module').then(m => m.EditTransitSlipModule)
      },
      // {
      //   path: 'form-apply/rule_19_1',
      //   loadChildren: () => import('./views/pages/applynew-save/applynew-save.module').then(m=> m.ApplynewSaveModule)
      // },
      {
        path: 'form-apply',
        loadChildren: () => import('./views/pages/dynamicform/dynamicform.module').then(m => m.DynamicFormModule)
      },
      {
        path: 'form-edit',
        loadChildren: () => import('./views/pages/dynamicform/dynamicform.module').then(m => m.DynamicFormModule)
      },
      {
        path: 'view/:id',
        loadChildren: () => import('./views/pages/applynew-view/applynew-view.module').then(m => m.ApplynewViewModule)
      },

      {
        path: 'transfer',
        loadChildren: () => import('./views/pages/transfer/application-transfer/application-transfer.module').then(m => m.ApplicationTrasferModule)
      },
      {
        path: 'transferlist',
        loadChildren: () => import('./views/pages/transfer/application-transferlist/application-transferlist.module').then(m => m.ApplicationTransferlistModule)
      },
      {
        path: 'transfer/edit/:id',
        loadChildren: () => import('./views/pages/transfer/application-transferedit/application-transferedit.module').then(m => m.ApplicationTrasferEditModule)
      },
      {
        path: 'withdraw/:id',
        loadChildren: () => import('./views/pages/application-withdraw/application-withdraw.module').then(m => m.ApplicationWithdrawModule)
      },
      {
        path: 'hold/:id',
        loadChildren: () => import('./views/pages/application-withdraw/application-withdraw.module').then(m => m.ApplicationWithdrawModule)
      },
      {
        path: 'unhold/:id',
        loadChildren: () => import('./views/pages/application-withdraw/application-withdraw.module').then(m => m.ApplicationWithdrawModule)
      },
      {
        path: 'reject/:id',
        loadChildren: () => import('./views/pages/application-withdraw/application-withdraw.module').then(m => m.ApplicationWithdrawModule)
      },
      {
        path: 'detail/:id',
        loadChildren: () => import('./views/pages/applynew-detail/applynew-detail.module').then(m => m.ApplynewDetailModule)
      },
      {
        path: 'timeline',
        loadChildren: () => import('./views/pages/timeline/timeline.module').then(m => m.TimelineModule)
      },
      {
        path: 'workflows',
        loadChildren: () => import('./views/pages/workflows/workflows.module').then(m => m.WorkflowsModule)
      },
      {
        path: 'steps/:id',
        loadChildren: () => import('./views/pages/workflow-steps/workflow-steps.module').then(m => m.WorkflowStepsModule)
      },
      {
        path: 'process/:id',
        loadChildren: () => import('./views/pages/application-process/application-process.module').then(m => m.ApplicationProcessModule)
      },
      {
        path: 'regusers',
        loadChildren: () => import('./views/pages/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'regusers/:id',
        loadChildren: () => import('./views/pages/application-process/application-process.module').then(m => m.ApplicationProcessModule)
      },
      {
        path: 'profile',
        loadChildren: () => import('./views/pages/profile/profile.module').then(m => m.ProfileModule)
      },
      {
        path: 'policies',
        loadChildren: () => import('./views/pages/policy/policy.module').then(m => m.PolicyModule)
      },
      {
        path: 'quarry',
        loadChildren: () => import('./views/pages/quarry/quarry.module').then(m => m.QuarryModule)
      },
      {
        path: 'userprofile',
        loadChildren: () => import('./views/pages/userprofile/userprofile.module').then(m => m.UserprofileModule)
      },
      {
        path: 'permit',
        loadChildren: () => import('./views/pages/permit/permit.module').then(m => m.PermitModule)
      },
      {
        path: 'dispatch',
        loadChildren: () => import('./views/pages/dispatch/dispatch.module').then(m => m.DispatchModule)
      },
      {
        path: 'mineralcost',
        loadChildren: () => import('./views/pages/mineralcost/mineralcost.module').then(m => m.MineralcostModule)
      },
      {
        path: 'driverlist',
        loadChildren: () => import('./views/pages/drivercombo/drivercombo.module').then(m => m.DrivercomboModule)
      },
      {
        path: 'transitpermits',
        loadChildren: () => import('./views/pages/transit-permit/transit-permit-list/transit-permit-list.module').then(m => m.TransitPermitListModule)
      },
      {
        path: 'applytransitpermit',
        loadChildren: () => import('./views/pages/transit-permit/transit-permit-add/transit-permit-add.module').then(m => m.TransitPermitAddModule)
      },
      {
        path: "editTransitPermit/:id",
        loadChildren: () => import("./views/pages/transit-permit/transit-permit-edit/transit-permit-edit.module").then(m => m.TransitPermitEditModule)
      },
      {
        path: "viewTransitPermit/:id",
        loadChildren: () => import("./views/pages/transit-permit/transit-permit-view/transit-permit-view.module").then(m => m.TransitPermitViewModule)
      },
      {
        path: 'applications-dashboard',
        loadChildren: () => import('./views/pages/cgm-dashboard/cgm-dashboard.module').then(m => m.CgmDashboardModule)
      },
      {
        path: 'minerals-dashboard',
        loadChildren: () => import('./views/pages/minerals-dasboard/minerals-dasboard.module').then(m => m.MineralsDasboardModule)
      },
      {
        path: "securitypaper-dashboard",
        loadChildren: () => import('./views/pages/securitypaper-dashboard/securitypaper-dashboard.module').then(m => m.SecuritypaperDashboardModule)
      },
      {
        path: 'vehicle-reports/:id',
        loadChildren: () => import('./views/pages/vehicle-reports/vehicle-reports.module').then((m => m.VehicleReportsModule))
      },
      {
        path: 'vehicle-gps-report',
        loadChildren: () => import('./views/pages/vehicle-gps-report/vehicle-gps-report.module').then((m => m.VehicleGpsReportModule))
      },
      {
        path: 'vehicle-gps-report/:id',
        loadChildren: () => import('./views/pages/vehicle-gps-report/vehicle-gps-report.module').then((m => m.VehicleGpsReportModule))
      },
      {
        path: 'district-mine-gps-report',
        loadChildren: () => import('./views/pages/district-mine-gps-report/district-mine-gps-report.module').then((m => m.DistrictMineGpsReportModule))
      },
      {
        path: 'individual-vehicle-reports/:id',
        loadChildren: () => import('./views/pages/individual-vehicle-reports/individual-vehicle-reports.module').then((m => m.IndividualVehicleReportsModule))
      },
      {
        path: "brickearthpermits",
        loadChildren: () => import('./views/pages/brickearth-permit/brickearth-permit-list/brickearth-permit-list.module').then(m => m.BrickearthPermitListModule)
      },
      {
        path: "applybrickearthpermit",
        loadChildren: () => import('./views/pages/brickearth-permit/brickearth-permit-add/brickearth-permit-add.module').then(m => m.BrickearthPermitAddModule)
      },
      {
        path: "editbrickearthpermit/:id",
        loadChildren: () => import('./views/pages/brickearth-permit/brickearth-permit-edit/brickearth-permit-edit.module').then(m => m.BrickearthPermitEditModule)
      },
      {
        path: 'otherstate-transitpasslist',
        loadChildren: () => import('./views/pages/transitpass-otherstate/other-transit-list/other-transit-list.module').then(m => m.OtherTransitListModule)
      },
      {
        path: "otherstate-applytransit",
        loadChildren: () => import('./views/pages/transitpass-otherstate/other-transit-apply/other-transit-apply.module').then(m => m.OtherTransitApplyModule)
      },
      {
        path: "otherstate-edittransit/:id",
        loadChildren: () => import('./views/pages/transitpass-otherstate/other-transit-edit/other-transit-edit.module').then(m => m.OtherTransitEditModule)
      },
      {
        path: 'otrlist',
        loadChildren: () => import('./views/pages/otr-form/otr-form.module').then(m => m.OtrFormModule)
      },
      {
        path: 'other-transitpasslist',
        loadChildren: () => import('./views/pages/direct-transit-pass/direct-transit-pass-list/direct-transit-pass-list.module').then(m => m.DirectTransitPassListModule)
      },
      {
        path: 'apply-other-transitpass',
        loadChildren: () => import('./views/pages/direct-transit-pass/direct-transit-pass-apply/direct-transit-pass-apply.module').then(m => m.DirectTransitPassApplyModule)
      },
      {
        path: 'view-other-transitpass/:id',
        loadChildren: () => import('./views/pages/direct-transit-pass/direct-transit-pass-view/direct-transit-pass-view.module').then(m => m.DirectTransitPassViewModule)
      },
      {
        path: 'search-by-vehicle',
        loadChildren: () => import('./views/pages/search-by-vehicle/search-by-vehicle.module').then(m => m.SearchByVehicleModule)
      },
      {
        path: 'bulk-permit-monitoring',
        loadChildren: () => import('./views/pages/bulk-permit-monitoring/bulk-permit-monitoring.module').then(m => m.BulkPermitMonitoringModule)
      },
      {
        path: 'weighbridge-enable',
        loadChildren: () => import('./views/pages/weighbridge-enable/weighbridge-enable.module').then(m => m.WeighbridgeEnableModule)
      },
      {
        path: 'ump-orders',
        loadChildren: () => import('./views/pages/ump-orders/ump-orders.module').then(m => m.UmpOrdersModule)
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ]
  },
  {
    path: 'error',
    component: ErrorPageComponent,
    data: {
      type: 404,
      title: 'Page Not Found',
      desc: 'Oopps!! The page you were looking for doesn\'t exist.'
    }
  },
  {
    path: 'error/:type',
    component: ErrorPageComponent
  },
  { path: '**', redirectTo: 'error', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top', useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
